<template>
    <component :is="componentForSlide" :slide="slide" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { Slide } from "../types";

import IntroCard from "../slides/IntroCard.vue";
import QuestionIntro from "../slides/QuestionIntro.vue";
import QuestionSlide from "../slides/QuestionSlide.vue";
import ScoreSlide from "../slides/ScoreSlide.vue";

const props = defineProps<{ slide: Slide }>();

const componentForSlide = computed(() => {
    switch (props.slide.kind) {
        case "introCard":
            return IntroCard;
        case "questionIntro":
            return QuestionIntro;
        case "question":
            return QuestionSlide;
        case "scoreSlide":
            return ScoreSlide;
        default:
            return IntroCard;
    }
});
</script>
